<template>
  <form id="create-goal-form" @submit.prevent="createGoal">
    <div>
      <div class="col-md-12 form-wrapper">
        <h2>Create Goal for {{ formatMonth(month) }}</h2>
        <div class="form-group mt-3">
          <label for="goal">Goal</label>
          <input
            type="number"
            id="goal"
            v-model="goalValue"
            name="goal"
            class="form-control"
            placeholder="30"
            step="0.25"
          />
        </div>
      </div>

      <div class="row g-3">
        <div class="d-flex justify-content-end mt-4">
          <router-link class="btn btn-primary btn-lg mr-2" to="/home"
            >Cancel</router-link
          >
          <button class="btn btn-success btn-lg" type="submit">
            Create Goal
          </button>
        </div>
      </div>

      <div class="alert alert-danger" role="alert" v-if="postError">
        Invalid backend request!
      </div>
    </div>
  </form>
</template>

<script>
import axios from "axios";
import { server, addSpaces, formatMonth } from "../../utils/helper";
import router from "../../router";

export default {
  data() {
    return {
      month: null,
      goalValue: 0.0,
      postError: false,
    };
  },
  created() {
    this.month = this.$route.params.month;
  },
  methods: {
    addSpaces,
    formatMonth,
    createGoal() {
      let goalData = {
        month: this.month,
        goalValue: this.goalValue,
        user: "",
      };
      this._submitToServer(goalData);
    },
    _submitToServer(goalData) {
      const bearerToken = localStorage.getItem("jwt");
      axios
        .post(`${server.baseUrl}/goals`, goalData, {
          headers: { Authorization: "Bearer " + bearerToken },
          redact: ["authorization"],
        })
        .then(() => {
          router
            .push({ name: "month", params: { month: this.month } })
            .catch((error) => {
              console.log(error);
              this.httpError = true;
            });
        });
    },
  },
};
</script>
